import { API } from "aws-amplify";

// CONDITION: 5 numbers (or 5 numbers + "-" + 4 numbers)
export const isValidZipCode = zip =>
  zip && typeof zip === "string" && zip.match(/^[0-9]{5}(?:-[0-9]{4})?$/);

// CONDITION: at least 4 alphanumeric characters
export const isValidNickName = nickname =>
  nickname &&
  typeof nickname === "string" &&
  nickname.match(/([^A-Za-z0-9]*[A-Za-z0-9]){4}/);

export const checkUniqueNickname = async (nickname = "", email = "") => {
  try {
    return await API.post("nickname", "", {
      body: { nickname, email }
    });
  } catch (e) {
    console.error("Error checking nickname's uniqueness", e);
    return {};
  }
};
